import { TranslationKeys } from 'messages';

export { Typograph } from './typograph.component';
export type TypographI18nKeys = TranslationKeys;
